
import { Component, OnInit, Input, Inject, OnDestroy } from '@angular/core';
import { RandomVideosService } from 'app/_service/video/random-videos.services';
import { Subscription } from 'rxjs';
import { ScreenSize, WindowService } from 'app/_service/screen-size.service';
// import { HttpClientHelper } from 'app/_service/http-helper';
// import { ApiUrlHelper } from 'app/_service/api-url-helper';
import { DnDialogService } from 'app/_modules/dn-dialog/dn-dialog.service';
// import { UsersState } from 'app/app.reducer';
// import { Store } from 'redux';
// import { AppStore } from 'app/app.store';
// import { delay, map, tap } from 'rxjs/operators';
// import { ToastService } from 'app/_service/toast/toast.service';
// import { TeaserDetailDialogService } from 'app/_modules/dialog/teaser-detail-dialog/teaser-detail-dialog.service';
// import { UserService } from '../_service/user/user.service';

@Component({
  selector: 'app-release-schedule',
  templateUrl: './release-schedule.component.html',
  styleUrls: ['./release-schedule.component.scss', '../index/index.share.scss']
})

export class ReleaseScheduleComponent implements OnInit, OnDestroy {

  categories = [
    { label: '全部', cid: '0,1,4', region: '' },
  ];
  @Input() category = null;
  @Input() set subcategory(list) {
    if (list) {
      if (list.length) {
        this.categories[0].cid = (list[0].id.split(',').splice(0, 3)).join(',')
      }

      for (var i = 0; i < list.length && i < this.maxshow; ++i) {

        this.categories.push({
          label: list[i].title,
          cid: list[i].id,
          region: list[i].region
        })
      }
    }
  }
  maxshow = 8;
  subscriptions: Array<Subscription> = [];
  videoList = [];
  contentLoading = true;

  screenType = ScreenSize;
  screenSize;

  schedule = [
    { label: '最近更新', date: '' },
    { label: '周一', date: '1' },
    { label: '周二', date: '2' },
    { label: '周三', date: '3' },
    { label: '周四', date: '4' },
    { label: '周五', date: '5' },
    { label: '周六', date: '6' },
    { label: '周日', date: '7' },

  ];

  key = new Date().getDay() + "";
  selectedCategory: { cid: string, region: string };

  teaserIndex;
  ifShowed = false;
  showedVideo;
  private unsub = null;
  user;
  favoriteLoading = false;

  hoveredCover = null;
  newStyle = true; // 启用新的悬停封面简介
  constructor(
    private _randomVideosService: RandomVideosService,
    private _windowService: WindowService,
    // @Inject(AppStore) private store: Store<UsersState>,
    private _dnDialogService: DnDialogService,
    // private _apiUrlHelper: ApiUrlHelper,
    // private _httpClientHelper: HttpClientHelper,
    //private _toastService: ToastService,
  //  private teaserDetailService: TeaserDetailDialogService,
   // private _userService:UserService
  ) {
    this._windowService.size$.subscribe((value: any) => {
      this.screenSize = value;
    });
  }
  selectDay(index, item) {
    if (this.key != item.date) {
      this.key = item.date;
      this.startLoadData();
    }

  }
  private startLoadData() {
    this._randomVideosService.getWeekRenewVideoBydata({
      cid: this.selectedCategory ? this.selectedCategory.cid : this.category.cid,
      region: this.selectedCategory ? this.selectedCategory.region : this.category.region ? this.category.region : "",
      key: this.key
    }).subscribe(p => {
      this.videoList = p;
    })
  }
  ngOnInit() {
    this.startLoadData();
    // this.unsub = this.store.subscribe(() => this.readState());
    // this.readState();
  }

  readState() {
    // const state: UsersState = this.store.getState()['users'] as UsersState;
    // this.user = state.currentUser;
  }

  selectcategory(item) {

    if (item !== this.selectedCategory) {
      this.selectedCategory = { ...item };
      this.startLoadData();
    }

  }
  // responsiveRowItems() {
  //   if (this.screenSize === this.screenType.XSmall) {
  //     return 5;
  //   }
  //   if (this.screenSize === this.screenType.Small) {
  //     return 6;
  //   }
  //   if (this.screenSize === this.screenType.Medium) {
  //     return 6;
  //   }
  //   if (this.screenSize === this.screenType.Large) {
  //     return 7;
  //   }
  //   return 8;
  // }

  responsiveMarginRight(isLast) {
    if (isLast) {
      return 0;
    }
    return 5;
  }

  // responsiveTeaserSize() {
  //   if (this.screenSize == this.screenType.Large) {
  //     return {
  //       width: 213,
  //       height: 357

  //     }
  //   }
  //   if (this.screenSize == this.screenType.ExtraLarge) {
  //     return {
  //       width: 216,
  //       height: 362
  //     };
  //   }
  //   return { width: 206, height: 348 };
  // }

  arrayCounter(i: number) {
    return new Array(i);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
    if (this.unsub) this.unsub();
  }

  showDetail(i, item) {
    this.teaserIndex = i;
    this.ifShowed = true;
    this.showedVideo = item;
    // console.log(item);
  }

  closeDetail(i) {
    this.teaserIndex = i;
    this.ifShowed = false;
  }

  replaceComma(r) {
    if (r !== null && r !== undefined) {
      return r.replace(/,/g, ' / ');
    }
  }

  openTeaserDialog($event: any, video) {
    $event.preventDefault();
    $event.stopPropagation();
    this._dnDialogService.open('teaser-detail-dialog',video);

    // this.teaserDetailService.setState(video);
    // setTimeout(() => {
    //   this._dnDialogService.open('teaser-detail-dialog');
    // }, 50);
  }

  // cidMapperArray(cidMapper) {
  //   return cidMapper.split(',');
  // }

}
